import { render, staticRenderFns } from "./RoleTree.vue?vue&type=template&id=6e16b02a&"
import script from "./RoleTree.vue?vue&type=script&lang=js&"
export * from "./RoleTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports